import { ref, computed, reactive, unref, watch } from 'vue'
import { defineStore } from 'pinia'
import { type Schedule } from './types'
import { faker } from '@faker-js/faker'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { useAppStore } from './app'
import { usePayslipStore } from './payslip'


dayjs.extend(utc)
dayjs.extend(timezone)

const tz = 'Asia/Manila'

import axios from 'axios'

const apiURL: string = import.meta.env.VITE_API_URL + '/api'

const api = axios.create({
  baseURL: apiURL + '/v1'
})

export const useScheduleStore = defineStore('schedule', () => {
  const appStore = useAppStore()

  const schedules = reactive(Array<Schedule>())
  const selectedSchedule = ref({} as Schedule) // selected in table
  const thisSchedule = ref({} as Schedule) //for form editing

  const showForm = ref(false)


  // uuid: string
  // account_number: string
  // account_side: ACCOUNT_SIDE
  // account_name: string
  // account_type: ACCOUNT_TYPE

  function generateSchedules(count = 100) {

    // for (let index = 0; index < count; index++) {
    //   addAccount()
    // }
    if (schedules.length == 0) {
      const payload = {} as Schedule
      // payload.uuid = faker.string.uuid()
      payload.code = 'MF8-5'
      payload.time_in = dayjs()
        .set('hour', 8)
        .set('minute', 30)
        .toDate()
      payload.time_break = dayjs()
        .set('hour', 12)
        .set('minute', 30)
        .toDate()
      payload.time_resume = dayjs()
        .set('hour', 13)
        .set('minute', 30)
        .toDate()
      payload.time_out = dayjs()
        .set('hour', 17)
        .set('minute', 30)
        .toDate()
      payload.day_hours = dayjs(payload.time_out).diff(dayjs(payload.time_in), 'hours')

      saveSchedule({ ...payload })

      // payload.uuid = faker.string.uuid()
      payload.code = 'MF2-10'
      payload.time_in = dayjs()
        .set('hour', 14)
        .set('minute', 0)
        .toDate()
      payload.time_break = dayjs()
        .set('hour', 18)
        .set('minute', 0)
        .toDate()
      payload.time_resume = dayjs()
        .set('hour', 19)
        .set('minute', 0)
        .toDate()
      payload.time_out = dayjs()
        .set('hour', 22)
        .set('minute', 0)
        .toDate()
      payload.day_hours = dayjs(payload.time_out).diff(dayjs(payload.time_in), 'hours')

      saveSchedule({ ...payload })
    }
  }

  // Times are stored as wall-clock strings; the timepicker holds local Dates.
  // Format explicitly so axios doesn't serialize Dates to UTC ISO (shifting -8).
  const toWallClock = (t: any) => (t ? dayjs(t).format('YYYY-MM-DD HH:mm:ss') : t)

  async function saveSchedule(payload_: Schedule) {
    const payload = Object.assign(
      {},
      {
        ...payload_,
        time_in: toWallClock(payload_.time_in),
        time_out: toWallClock(payload_.time_out),
        time_break: toWallClock(payload_.time_break),
        time_resume: toWallClock(payload_.time_resume)
      }
    )

    
    if (payload.uuid) {
      const response = await api.put('/schedules/' + payload.uuid, payload)

      if (response.status == 200) {
        const idx = schedules.findIndex((item: Schedule) => item.uuid == payload.uuid)
        schedules.splice(idx, 1, response.data)

        // shift times / breaks / work days changed: recalc affected payslips
        usePayslipStore().dirtyAffectedPayslips({ schedule_uuid: payload.uuid })
      } else {
      }
    } else {
      const response = await api.post('/schedules.json', payload)

      if (response.status == 200) {
        if ('errors' in response.data) {
          appStore.errors = response.data.errors
          showForm.value = true
        } else {
          schedules.push(response.data)
          appStore.errors = {}
          showForm.value = false

        }
      } else {
      }
    }
  }

  async function addSchedule(payload_: Schedule) {
    const payload = Object.assign(
      {},
      {
        ...payload_,
        time_in: toWallClock(payload_.time_in),
        time_out: toWallClock(payload_.time_out),
        time_break: toWallClock(payload_.time_break),
        time_resume: toWallClock(payload_.time_resume)
      }
    )

    const response = await api.post('/schedules.json', payload)

    if (response.status == 200) {
      if ('errors' in response.data) {
        appStore.errors = response.data.errors
        showForm.value = true
      } else {
        schedules.push(response.data)
        appStore.errors = {}
        showForm.value = false

      }
    } else {
    }
  }

  async function deleteSchedule(payload: Schedule) {
    const response = await api.delete('/schedules/' + payload.uuid)

    if (response.status == 200) {
      const idx = schedules.findIndex((item: Schedule) => item.uuid == payload.uuid)
      schedules.splice(idx, 1)

      usePayslipStore().dirtyAffectedPayslips({ schedule_uuid: payload.uuid })
    } else {
    }
  }

  async function getSchedules() {

    const response = await api.get('/schedules.json')
    if (response.status == 200) {
      Object.assign(schedules,[])
      Object.assign(schedules,response.data.data)
      // schedules.length = 0
      // response.data.data.forEach((item: Schedule) => {
      //   schedules.push(item)
      // })
    } else {
    }
  }

  const scheduleCode = computed(()=>(uuid: string)=>{
    return schedules.find((item: Schedule)=>item.uuid == uuid)?.code

  })

  return {
    showForm,
    schedules,
    selectedSchedule,
    thisSchedule,

    generateSchedules,
    getSchedules,
    saveSchedule,
    addSchedule,
    deleteSchedule,

    scheduleCode
  }
})
